import { firebase } from '../firebase/firebase';
//Actions
import { getPlaceClans, getPlaceUsers } from './place';

const addClanFunction = firebase
  .functions()
  .httpsCallable('httpsDashboardAddClan');
const addKeyFunction = firebase
  .functions()
  .httpsCallable('httpsDashboardAddKey');
const getUserUidByPhoneNumberFunction = firebase
  .functions()
  .httpsCallable('httpsDashboardGetUserUidByPhoneNumber');
const removeKeyFunction = firebase
  .functions()
  .httpsCallable('httpsDashboardRemoveKey');

export const addClan = ({ address, members, name, tags }) => {
  return async (dispatch, getState) => {
    const clan = { status: { place: true }, address, name, tags };
    const place = getState().place.uid;
    const functionObject = { clan, place };
    const clanUid = await addClanFunction(functionObject).then(
      (res) => res.data
    );
    await dispatch(getPlaceClans(place, true));
    await dispatch(addMembers(members, clanUid));
    await dispatch(getPlaceUsers(place, true));
    return dispatch(clanChanged(clanUid, clan));
  };
};

export const addKey = (clan, phoneNumber) => {
  return (dispatch, getState) => {
    const place = getState().place.uid;
    return getUserUidByPhoneNumberFunction({ phoneNumber }).then((res) => {
      const user = res.data;
      let key = {};
      key[place] = { clan };
      return addKeyFunction({ key, user });
    });
  };
};

export const addMembers = (members, clan) => {
  return (dispatch) => {
    const promises = [];
    members.map((phoneNumber) => {
      promises.push(dispatch(addKey(clan, phoneNumber)));
    });
    return Promise.all(promises);
  };
};

export const attachListeners = (clansRef) => {
  return (dispatch, getState) => {
    clansRef.on('child_added', (clanSnap) => {
      if (getState().clans.data.length > 0) {
        dispatch(clanAdded(clanSnap.key, clanSnap.val()));
      }
    });
    clansRef.on('child_changed', (clanSnap) => {
      dispatch(clanChanged(clanSnap.key, clanSnap.val()));
    });
    clansRef.on('child_removed', (clanSnap) => {
      dispatch(clanRemoved(clanSnap.key));
    });
  };
};

export const clanAdded = (clanUid, rawClan) => {
  return async (dispatch) => {
    const clan = await dispatch(processClan(clanUid, rawClan));
    dispatch(pushClan(clan));
  };
};

export const clanChanged = (clanUid, rawClan) => {
  return async (dispatch, getState) => {
    const clans = getState().clans.data;
    const index = clans.findIndex((clan) => clan.id === clanUid);
    const clan = await dispatch(processClan(clanUid, rawClan));
    clan['status'] =
      typeof clan.status === 'boolean' ? clan.status : clans[index].status;
    //Push new clan or update existing clan
    index < 0 ? clans.push(clan) : (clans[index] = clan);
    dispatch(setClans(clans));
  };
};

export const clanRemoved = (clanUid, clan) => {
  return (dispatch, getState) => {
    const clans = getState().clans.data;
    const index = clans.findIndex((clan) => clan.id === clanUid);
    clans.splice(index, 1);
    dispatch(setClans(clans));
  };
};

export const getClans = (placeUid) => {
  return async (dispatch, getState) => {
    const placeUid = getState().place.uid;
    const clansRef = firebase
      .database()
      .ref(`places/${placeUid}/clans`)
      .orderByChild('address');
    dispatch(attachListeners(clansRef));
    const clansSnap = await clansRef.once('value');
    let promises = [];
    clansSnap.forEach((clanSnap) => {
      promises.push(dispatch(processClan(clanSnap.key, clanSnap.val())));
    });
    const clans = await Promise.all(promises);
    dispatch(setClans(clans));
  };
};

export const getClanMembers = (clanUid) => {
  return (dispatch, getState) => {
    const { users, usersQueue } = getState().place;
    let members = [];
    return new Promise((resolve, reject) => {
      Object.keys(users).map((user) => {
        if (users[user]['clan'] === clanUid) {
          members.push(user);
        }
      });
      Object.keys(usersQueue).map((user) => {
        if (usersQueue[user]['clan'] === clanUid) {
          members.push(user);
        }
      });
      resolve(members);
    });
  };
};

export const processClan = (clanUid, clan) => {
  return async (dispatch, getState) => {
    clan['id'] = clanUid;
    clan['tags'] = clan.tags ? Object.keys(clan.tags) : [];
    const members = await dispatch(getClanMembers(clanUid));
    clan['members'] = members;
    if (clan.status) {
      clan['suscription'] = clan.status.locki;
      clan['status'] = clan.status.place;
    }
    return clan;
  };
};

export const removeClan = (clanUid) => {
  return (dispatch, getState) => {
    const placeUid = getState().place.uid;
    const clanRef = firebase
      .database()
      .ref(`places/${placeUid}/clans/${clanUid}`);
    return clanRef.remove().catch((error) => console.log(error));
  };
};

export const removeKey = (user) => {
  return (dispatch, getState) => {
    const place = getState().place.uid;
    return removeKeyFunction({ place, user });
  };
};

export const removeMembers = (members) => {
  return (dispatch) => {
    const promises = [];
    members.map((userUid) => {
      promises.push(dispatch(removeKey(userUid)));
    });
    return Promise.all(promises);
  };
};

export const saveClanData = (clan) => {
  return (dispatch) => {
    return clan.id ? dispatch(updateClan(clan)) : dispatch(addClan(clan));
  };
};

export const toggleClanStatus = (clan, status) => {
  return (dispatch, getState) => {
    const place = getState().place.uid;
    const statusRef = firebase
      .database()
      .ref(`places/${place}/clans/${clan}/status/place`);
    statusRef.set(!status);
  };
};

export const updateClan = (clan) => {
  return (dispatch, getState) => {
    const placeUid = getState().place.uid;
    let newMembers = clan.members;
    const currentMembers = getState().clans.data.find(
      (element) => element.id === clan.id
    ).members;
    const deprecatedMembers = currentMembers.filter(
      (x) => !newMembers.includes(x)
    );
    newMembers = newMembers.filter((x) => !currentMembers.includes(x));
    const clansRef = firebase
      .database()
      .ref(`places/${placeUid}/clans/${clan.id}`);
    const updates = [
      clansRef.update({
        address: clan.address,
        name: clan.name,
        tags: clan.tags,
      }),
      dispatch(addMembers(newMembers, clan.id)),
      dispatch(removeMembers(deprecatedMembers)),
    ];
    return Promise.all(updates).then(() => {
      return dispatch(getPlaceUsers(placeUid, true)).then(() => {
        return dispatch(
          clanChanged(clan.id, {
            address: clan.address,
            name: clan.name,
            tags: clan.tags,
          })
        );
      });
    });
  };
};

export const pushClan = (clan) => ({
  type: 'PUSH_CLAN',
  clan,
});

export const setClans = (clans) => ({
  type: 'SET_CLANS',
  clans,
});
